import $ from 'jquery';
import { CohortStore } from '../stores/CohortStore';
import * as utilities from '../../utilities/legacy-utilities';

// TODO other notification types, i18n, and generally be better
const _getDisplayText = (rawNotification) => {
  return rawNotification.messagePlainNoCohort;
};

class Notification {
  constructor(raw) {
    if (raw) {
      this._raw = raw;
      this.id = raw._riot_id || raw._id;
      this.action = raw.action;
      this.actors = raw.actors;
      this.channelId = raw.channelId;
      this.subscriptionId = raw.subscriptionId;
      this.coursePath = raw.coursePath;
      this.cohortPath = raw.cohortPath;
      this.displayText = _getDisplayText(raw);
      this.formattedTimeStamp = utilities.formatTimestamp(raw.timestamp);
      this.image = raw.imageUrl;
      this.lastCheckedTime = raw.lastCheckedTime;
      this.timestamp = raw.timestamp;
      this.messageComponents = raw.messageComponents;
      this.postId = raw.postId;
    }
  }

  copy() {
    const result = new Notification(null);
    $.extend(result, this, true);
    return result;
  }

  isUnread() {
    return !this.lastCheckedTime || this.lastCheckedTime < this.timestamp;
  }

  get link() {
    if (this._raw.notificationLinkPath.indexOf('?') !== -1) {
      return `${this._raw.domain}/${this._raw.notificationLinkPath}&${this._raw.notificationLinkQueryString}`;
    } else {
      return `${this._raw.domain}/${this._raw.notificationLinkPath}?${this._raw.notificationLinkQueryString}`;
    }
  }

  get cohortString() {
    const cohort = CohortStore.getCohort(this._raw.cohortPath);
    if (!cohort) {
      return null;
    }
    return `${cohort.courseTitle} (${cohort.cohortTitle})`;
  }

  get isForCohort() {
    return !!this._raw.cohort;
  }
}

export const NotificationUtils = {
  convertRawNotification: (raw, previous) => {
    if (previous) {
      if (previous.lastCheckedTime > raw.lastCheckedTime) {
        raw.lastCheckedTime = previous.lastCheckedTime; // eslint-disable-line no-param-reassign
      }
    }
    return new Notification(raw);
  },

  convertRawSubscription: (raw) => {
    const result = {};
    $.extend(result, raw, true);
    return result;
  },

  serverSettingsFromClient: (clientSettings) => {
    const settings = {};
    $.extend(settings, clientSettings, true);
    if (!settings.emailNotificationSettings) {
      settings.emailNotificationSettings = {};
    }
    settings.emailNotificationSettings.frequency = settings.emailNotification
      ? 'immediately'
      : 'never';
    delete settings.emailNotification;
    return settings;
  },

  clientSettingsFromServer: (serverSettings) => {
    const settings = {};
    $.extend(settings, serverSettings, true);
    if (settings.emailNotificationSettings) {
      settings.emailNotification =
        settings.emailNotificationSettings.frequency === 'immediately';
      delete settings.emailNotificationSettings;
    } else {
      settings.emailNotification = false;
    }
    return settings;
  },
};
